import { render, staticRenderFns } from "./DateInputMethodSelector.vue?vue&type=template&id=2b09882e&scoped=true&"
import script from "./DateInputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./DateInputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09882e",
  null
  
)

export default component.exports